/* IconSingleSelectListControlComponent.js */

"use strict";
const _ = require("lodash");
const SingleSelectListControlComponent = require("../single/SingleSelectListControlComponent");
const Renderer = require("./IconSingleSelectListControlRenderer");

class IconSelectListControlComponent extends SingleSelectListControlComponent {
    /**
     * @schema.name Select List Control
     * @schema.package @gluenetworks/select_list
     * @schema.packageIdentifier Single
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.Icon.SelectList
     * @schema.events ["Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } }]
     *
     * @schema.configuration.value.example { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }
     *
     * @schema.configuration.optionIcon.name optionIcon
     * @schema.configuration.optionIcon.type string
     * @schema.configuration.optionIcon.default
     * @schema.configuration.optionIcon.required false
     *
     * @schema.configuration.selectedOptionIcon.name selectedOptionIcon
     * @schema.configuration.selectedOptionIcon.type string
     * @schema.configuration.selectedOptionIcon.default
     * @schema.configuration.selectedOptionIcon.required false
     */

    constructor(configOptions) {
        super(configOptions);
        this._optionIcon = _.get(configOptions, "optionIcon", false);
        this._selectedOptionIcon = _.get(configOptions, "selectedOptionIcon", false);
        this._renderer = new Renderer(this);
    }

    hasOptionIcons() {
        return _.isString(this._optionIcon) || _.isFunction(this._optionIcon);
    }

    hasSelectedOptionIcons() {
        return _.isString(this._selectedOptionIcon) || _.isFunction(this._selectedOptionIcon);
    }

    getOptionIcon(optionValue) {
        let isSelected = _.isEqual(optionValue, this._value);
        if (isSelected) {
            return this.getSelectedOptionIcon(optionValue);
        }
        if (_.isString(this._optionIcon)) {
            return this._optionIcon;
        } else if (_.isFunction(this._optionIcon)) {
            return this._optionIcon(optionValue);
        } else {
            return "common.check";
        }
    }
    getSelectedOptionIcon(optionValue) {
        if (_.isString(this._selectedOptionIcon)) {
            return this._selectedOptionIcon;
        } else if (_.isFunction(this._selectedOptionIcon)) {
            return this._selectedOptionIcon(optionValue);
        } else {
            return "common.check";
        }
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._selectedOptionIcon = undefined;
        this._optionIcon = undefined;
        return super.shutdown();
    }
}
module.exports = IconSelectListControlComponent;
